import React, { useEffect } from 'react';
import { Switch, Route, BrowserRouter as Router } from 'react-router-dom';
import MainApp from './MainApp';
import './_i18n';
import initGoogleAnalytics from './utils/google-analytics';
import './styles/App.scss';
import { subscribeToAnalyticsConsent } from './utils/consent';
function App() {
  useEffect(() => {
    let analyticsStarted = false;

    const unsubscribe = subscribeToAnalyticsConsent((allowed) => {
      if (allowed && !analyticsStarted) {
        analyticsStarted = true;
        initGoogleAnalytics();
      }
    });

    return () => {
      if (typeof unsubscribe === 'function') {
        unsubscribe();
      }
    };
  }, []);

  return (
    <Router>
      <Switch>
        <Route exact path="/gtin/:gtin" component={MainApp}></Route>
        <Route exact path="/supc/:supc" component={MainApp}></Route>
      </Switch>
    </Router>
  );
}

export default App;
